<template>
  <b-container class="pb-3">
    <b-row>
      <b-col md="6" offset-md="3">
        <b-form-group label="Company Name">
          <b-form-input name="name" autocomplete="organization" v-model="draft.companyName"></b-form-input>
        </b-form-group>
        <b-form-group label="Company Website (if any)">
          <b-form-input name="email" type="url" autocomplete="url" v-model="draft.companyWebsite"></b-form-input>
        </b-form-group>
        <b-button block variant="primary" @click="next()">Next</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import $member from '@/services/member';

export default {
  components: {
  },
  data() {
    return {
      draft: {
      },
    };
  },
  methods: {
    async next() {
      await $member.updateCompanyInfo(this.draft);
      this.$router.push({ name: 'Interview', params: { qid: 'primaryChallenges' } });
    },
  },
};

</script>
